import React, { useState, useEffect } from 'react'
import { ProductApi, type ProductInfoDto } from '../../../common/services'

interface RenderImageProductProps {
  row: ProductInfoDto
}

const RenderImageProduct = ({ row }: RenderImageProductProps): JSX.Element => {
  console.log(row)
  const [imageUrl, setImageUrl] = useState<string | null>(null)
  useEffect(() => {
    void fetchImage(row.id ?? 0)
  }, [row.id])

  const fetchImage = async (id: number): Promise<void> => {
    try {
      const response = await new ProductApi().apiV2ProductDownloadIdGet(id) as any
      // Kiểm tra nếu response.error có dữ liệu base64
      if (response.data.data != null) {
        // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
        setImageUrl(`data:image/png;base64,${response?.data.data}`)
      }
    } catch (error) {
      console.log('error', error)
    }
  }

  return (imageUrl != null)
    ? (
    <img
      width={50}
      height={30}
      style={{ objectFit: 'contain', cursor: 'pointer' }}
      src={imageUrl}
      alt={row.name ?? ''}
    />
      )
    : (
    <div style={{ width: 50, height: 30, backgroundColor: '#f0f0f0' }} />
      )
}

export default RenderImageProduct
